import {
    cilBank,
    cilCamera,
    cilEnvelopeClosed,
    cilHistory,
    cilHome,
    cilLockLocked,
    cilMap,
    cilMenu,
    cilNewspaper,
    cilPenAlt,
    cilPeople,
    cilShieldAlt,
    cilTask,
} from '@coreui/icons'

export const iconsSet = Object.assign(
    {},
    {
        cilBank,
        cilCamera,
        cilEnvelopeClosed,
        cilHistory,
        cilHome,
        cilLockLocked,
        cilMap,
        cilMenu,
        cilNewspaper,
        cilPenAlt,
        cilPeople,
        cilShieldAlt,
        cilTask,
    }
)
